import type { UpdateSystem } from "@engine/core/Lifecycle";
import type { Game } from "@engine/core/Game";
import type { EcsWorld } from "../world";

/** Reads input + ActionMap and writes velocity for entities tagged `localControlled`. */
export class PlayerControlSystem implements UpdateSystem {
  private query;

  constructor(
    world: EcsWorld,
    private readonly game: Game,
    private readonly speed = 200,
  ) {
    this.query = world.with("velocity", "localControlled");
  }

  update(_dt: number): void {
    const { input, actions } = this.game;
    const dx = actions.axis(input, "move-left", "move-right");
    const dy = actions.axis(input, "move-up", "move-down");
    const len = Math.hypot(dx, dy) || 1;
    const vx = (dx / len) * this.speed * (len > 0 ? 1 : 0);
    const vy = (dy / len) * this.speed * (len > 0 ? 1 : 0);

    for (const e of this.query) {
      e.velocity.x = vx;
      e.velocity.y = vy;
      if (typeof e.heading === "number" && (vx !== 0 || vy !== 0)) {
        e.heading = Math.atan2(vy, vx);
      }
    }
  }
}
